export default __webpack_public_path__ + "static/media/ep3collage4.9d58e6ab.jpg";